import script from "./Main-Navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./Main-Navigation.vue?vue&type=script&setup=true&lang=js"

import "./Main-Navigation.vue?vue&type=style&index=0&id=0de68bee&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de68bee"]])

export default __exports__